'use strict';

var ConfigurationLinkedFbcTransformerFactory = function ConfigurationLinkedFbcTransformerFactory(DataTransformer, momentService) {
  function ConfigurationLinkedFbcTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-linked-fbc-mode';
  }
  ConfigurationLinkedFbcTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationLinkedFbcTransformer.constructor = ConfigurationLinkedFbcTransformer;
  ConfigurationLinkedFbcTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationLinkedFbcTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationLinkedFbcTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationLinkedFbcTransformer.prototype.transform = function (data) {
    var linkedFbcList = data.domain.linkedFbcList;
    var result = [];
    for (var i = 0; i < linkedFbcList.length; i++) {
      var linkedFbc = linkedFbcList[i];
      var transformedLinkedFbc = linkedFbc;
      transformedLinkedFbc.linkedCabin = linkedFbc.cabin;
      transformedLinkedFbc.adaptivePricingCategory = linkedFbc.category;
      transformedLinkedFbc.foOriginCountry = linkedFbc.originCountry;
      transformedLinkedFbc.foDestCountry = linkedFbc.destinationCountry;
      transformedLinkedFbc.foSponsorCarrier = linkedFbc.sponsorCarrier;
      transformedLinkedFbc.foSponsorOrigin = linkedFbc.sponsorOrigin;
      transformedLinkedFbc.foTargetCarrier = linkedFbc.targetCarrier;
      transformedLinkedFbc.foTargetOrigin = linkedFbc.targetOrigin;
      transformedLinkedFbc.foSponsorDestination = linkedFbc.sponsorDestination;
      transformedLinkedFbc.foTargetDestination = linkedFbc.targetDestination;
      transformedLinkedFbc.targetCurrencyCode = linkedFbc.targetCurrencyCode;
      transformedLinkedFbc.currencyConversion = linkedFbc.currencyConversion;
      transformedLinkedFbc.percentageIndicator = linkedFbc.percentageIndicator === true ? 'P' : 'A';
      transformedLinkedFbc.lastUpdatedDate = momentService.of(linkedFbc.lastUpdatedDate, momentService.FIELD.SYSTEM_CONFIGURATION_DATE);
      result.push(transformedLinkedFbc);
    }
    return result;
  };
  return ConfigurationLinkedFbcTransformer;
};
ConfigurationLinkedFbcTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = ConfigurationLinkedFbcTransformerFactory;